"use client";import{useContext as t}from"react";import{ToastContext as o}from"../ToastContext.mjs";const r=()=>t(o);export{r as useToast};
